import { fetchStorageFile } from 'hooks/StoreFiles';
import React from 'react';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        background-color: #eae8e6;
        font-family: 'Barlow', sans-serif;
        padding-top: 80px;
        padding-bottom: 20px;
    `,

    Content: styled.div`
        display: flex;
        flex-direction: column;
        padding-left: 80px;
        gap: 22px;


        @media screen and (max-width: 1280px){
            padding-left: 20px;
        }

        @media screen and (max-width: 800px){ 
            margin-right: 20px !important;
        }

    `,

    Footer: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 90%;
        margin-top: 20px;
        background: #01245e;
        color: white;
        padding-left: 80px;
        background: linear-gradient(90deg, rgba(1, 36, 94, 1) 0%, rgba(4, 64, 161, 1) 50%, rgba(13, 94, 227, 1) 100%);

        img {
            width: 60px;
            position: relative;
            left: 40px;
        }
        

        @media screen and (max-width: 600px) {
            padding-left: 20px;
            
        }
    `,
};

interface PageTemplatePlanoAnualProps {
    children?: React.ReactNode;
    numberPage?: number;
    stylesContent?: React.CSSProperties;
    stylesContainer?: React.CSSProperties;
}

const PageTemplatePlanoAnual: React.FC<PageTemplatePlanoAnualProps> = ({ children, numberPage, stylesContent, stylesContainer }) => {
    return (
        <Styled.Container style={stylesContainer}>
            <Styled.Content style={stylesContent}>{children}</Styled.Content>

            {numberPage && numberPage > 0 && (
                <Styled.Footer>
                    <span style={{fontWeight: "bold"}}>{numberPage}</span>
                    <div style={{ display: 'flex', alignItems: ' center' }}>
                        <span>
                            Plano Anual <strong>Instituto Ayrton Senna</strong>{' '}
                        </span>
                        <img style={{borderRadius: 0}} src={fetchStorageFile('anexo_storage_files_9243436125584841884.png_2025-11-19-1763553796359.png')} alt="" />
                    </div>
                </Styled.Footer>
            )}
        </Styled.Container>
    );
};

export default PageTemplatePlanoAnual;
